import { debounce } from "lodash";
import { useCallback } from "react";
import { AppDispatch } from "../slices/store";

const useDebouncedDispatch = (dispatch: AppDispatch, delay: number = 300) => {
  return useCallback(
    debounce((actionCreator: (args: any) => any, args: any) => {
      dispatch(actionCreator(args));
    }, delay),
    [dispatch, delay]
  );
};

export default useDebouncedDispatch;